import { httpApi } from '@app/api/http.api'

import { CreateDocumentsPayload, RodoDocumentsResponse } from './rodo-policies.api'

const DATA_PROCESSING_CONSENT = 'data-processing-consent'

export const getDataProcessingConsents = (): Promise<RodoDocumentsResponse[]> =>
  httpApi.get<RodoDocumentsResponse[]>(`${DATA_PROCESSING_CONSENT}/all`).then(({ data }) => data)

export const getActiveDataProcessingConsent = (): Promise<{
  id: string
  name: string
  documentationFile: {
    content: string
    name: string
    type: string
  }
} | null> => httpApi.get(`${DATA_PROCESSING_CONSENT}/active`).then(({ data }) => data)

export const createDataProcessingConsent = (payload: CreateDocumentsPayload): Promise<string> =>
  httpApi.post<string>(`${DATA_PROCESSING_CONSENT}/create`, payload).then(({ data }) => data)
